import { Injectable } from '@angular/core';
import { SessionSecurityService } from '@shared/services';
import { MemberSearchService } from './member-search.service';

 
@Injectable()
export class UserDataService {
 
    userData: any;
  
  constructor(
    private memberSearchService: MemberSearchService, 
    private sessionSecurity: SessionSecurityService) 
  {
      
    this.memberSearchService.getMyInfo(this.sessionSecurity.getObject('UserId')).subscribe(me => {
        this.userData = me;
    });
  }
 
    getItems(){
        return this.userData;
    }
}